import makeStyles from "@mui/styles/makeStyles";

const sliderLabel = {
  flex: 1,
  display: "inline-block",
  textOverflow: "ellipsis",
  overflow: "hidden",
  whiteSpace: "nowrap",
};

const useStyles = makeStyles({
  rail: {
    height: 6,
    borderRadius: 4,
    backgroundColor: "grey",
  },
  track: {
    height: 6,
    borderRadius: 4,
  },
  thumb: {
    width: 18,
    height: 18,
    backgroundColor: "white",
    border: "4px solid",
  },
  sliderLabels: {
    display: "flex",
    justifyContent: "space-between",
  },
  leftLabel: {
    ...sliderLabel,
    textAlign: "left",
  },
  centerLabel: {
    ...sliderLabel,
    textAlign: "center",
  },
  rightLabel: {
    ...sliderLabel,
    textAlign: "right",
  },
});

export default useStyles;
